import React from 'react'
import { useSelector } from 'react-redux'
import { Outlet, Navigate, useLocation } from 'react-router-dom'


function PrivateRoute() {
  
  const { token: isAuth } = useSelector(state => state.auth)
  const location = useLocation()
  
  return isAuth ? <Outlet/> : <Navigate to='/auth' state={{ from: location }} replace />
}


export { PrivateRoute }